import { Button, Form } from "react-bootstrap";
import {
  addTransmission,
  getCapacitadores,
} from "@helpers/httpRequests/httpRequestsAulaVirtual/httpRequestsAulaVirtual";

import { Notificacion } from "@components/general/Alertas/Alertas";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

const AgregarTransmision = ({ setTransmisionAgregada }) => {
  // const [showModal, setShowModal] = useState(show);

  const [capacitadores, setCapacitadores] = useState([]);

  const [formValues, setFormValues] = useState({
    titulo: "",
    descripcion: "",
    urlTransmision: "",
    idCapacitador: 0,
  });

  const { titulo, descripcion, urlTransmision, idCapacitador } = formValues;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!urlTransmision.includes("embed")) {
      return Notificacion("error", "Ingresa un enlace válido");
    }

    if (idCapacitador === 0) {
      return Notificacion(
        "error",
        "Selecciona el capacitador a cual asignar esta transmisión"
      );
    }

    try {
      await addTransmission(formValues);

      Notificacion("success", "Transmisión agregada correctamente");

      setTransmisionAgregada(true);
    } catch (error) {
      console.log("Error al agregar la transmisión: ", error);

      Notificacion(
        "error",
        "Error al agregar la transmisión, vuelve a intentar"
      );
    }
  };

  const handleOnChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  const handleCapacitadorSelection = ({ target }) => {
    setFormValues({
      ...formValues,
      idCapacitador: target.value,
    });
  };

  useEffect(() => {
    const obtenerInformacionCapacitadores = async () => {
      try {
        const { data } = await getCapacitadores();

        setCapacitadores(data);
      } catch (error) {
        console.log("error al obtener los capacitadores: ", error);

        Notificacion("error", error.message);
      }
    };

    obtenerInformacionCapacitadores();
  }, []);

  return (
    <Form onSubmit={handleSubmit} className="text-start">
      <Form.Group>
        <Form.Label>Titulo de la transmisión</Form.Label>

        <Form.Control
          type="text"
          name="titulo"
          onChange={handleOnChange}
          value={titulo}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Descripción</Form.Label>

        <Form.Control
          type="text"
          name="descripcion"
          onChange={handleOnChange}
          value={descripcion}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Enlace de la transmisión</Form.Label>

        <Form.Control
          type="text"
          name="urlTransmision"
          onChange={handleOnChange}
          value={urlTransmision}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Capacitador</Form.Label>
        <Form.Control as="select" onChange={handleCapacitadorSelection}>
          <option value="0">Selecciona una opción</option>
          {capacitadores.map((capacitador, idx) => (
            <option key={idx} value={capacitador.idCapacitador}>
              {capacitador.nombre}
            </option>
          ))}
        </Form.Control>
      </Form.Group>

      <div className="d-grid gap-2 mt-4">
        <Button variant="success" type="submit" size="lg">
          Agregar
        </Button>
      </div>
    </Form>
  );
};

export default AgregarTransmision;
